import {Injectable} from "@angular/core";
import {HttpEvent, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {environment} from "@env/environment";


@Injectable()
export abstract class BackendHttpInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>): Observable<HttpEvent<any>> {
    // /api/endpoint?params=n
    const fullUrl = request.url.split("?");

    // /api/endpoint
    const basePath = fullUrl.length > 0 ? fullUrl[0] : '';

    // /endpoint
    const baseApiUrl = basePath.split(environment.baseUrlApi + '/');
    const rspEndpoint = baseApiUrl.length > 1 ? baseApiUrl[1] : '';

    // params=n
    const paramsMap = fullUrl.length > 1 ?
      fullUrl[1].split("&").map( (param) => param.split("="))
      : [];


    const data = this.mockCall(rspEndpoint, paramsMap)

    return of(new HttpResponse({status: 200, body: data}));
  }

  protected abstract mockCall(endpointPath: string, params: string[][]);
}
